var React = require('react');

function More (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none"},React.createElement("path",{"fill":"#000","d":"M9,12 C9,10.3431458 10.3431458,9 12,9 C13.6568542,9 15,10.3431458 15,12 C15,13.6568542 13.6568542,15 12,15 C10.3431458,15 9,13.6568542 9,12 Z M9,20 C9,18.3431458 10.3431458,17 12,17 C13.6568542,17 15,18.3431458 15,20 C15,21.6568542 13.6568542,23 12,23 C10.3431458,23 9,21.6568542 9,20 Z M9,4 C9,2.34314575 10.3431458,1 12,1 C13.6568542,1 15,2.34314575 15,4 C15,5.65685425 13.6568542,7 12,7 C10.3431458,7 9,5.65685425 9,4 Z"})));
}

More.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = More;

More.default = More;
